/** Il portale clienti (app QBI Clienti) si apre all'indirizzo /clienti (Luan 03/11/2026 22:20: «invece di /portale chiamalo /clienti») o su un
 *  sottodominio «clienti.» o «portale.» (es. clienti.qtrans.it). Il vecchio /portale resta valido e porta a /clienti. */
export function ePortale(host: string, percorso: string): boolean {
  return /^(clienti|portale)\./i.test(host) || /^\/(clienti|portale)\/?$/i.test(percorso);
}

/** Indirizzo vecchio (/portale): dove portarlo, con gli stessi parametri (es. ?cliente= dell'anteprima). Null se non serve. */
export function nuovoIndirizzo(percorso: string, ricerca: string, ancora: string): string | null {
  return /^\/portale\/?$/i.test(percorso) ? `/clienti${ricerca}${ancora}` : null;
}
